import { FormEvent, ReactNode } from 'react';

type FormContainerProps = {
  children: ReactNode;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  sx?: React.CSSProperties;
};

export const FormContainer = ({
  children,
  onSubmit,
  sx,
}: FormContainerProps) => {
  return (
    <form
      onSubmit={onSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        ...sx,
      }}
    >
      {children}
    </form>
  );
};
